/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import InsurancePoliciesInsurancePolicySubscriberAttributesAddressesAttributes from './InsurancePoliciesInsurancePolicySubscriberAttributesAddressesAttributes';
import PatientsPatientEthnicities from './PatientsPatientEthnicities';
import PatientsPatientRaces from './PatientsPatientRaces';
import PatientsidPatientPhonesAttributes from './PatientsidPatientPhonesAttributes';

/**
 * The PatientsidPatient model module.
 * @module model/PatientsidPatient
 * @version v0.3
 */
export default class PatientsidPatient {
  /**
   * Constructs a new <code>PatientsidPatient</code>.
   * @alias module:model/PatientsidPatient
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PatientsidPatient</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientsidPatient} obj Optional instance to populate.
   * @return {module:model/PatientsidPatient} The populated <code>PatientsidPatient</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientsidPatient();
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('source_status'))
        obj.sourceStatus = ApiClient.convertToType(data['source_status'], 'String');
      if (data.hasOwnProperty('epic_mrn'))
        obj.epicMrn = ApiClient.convertToType(data['epic_mrn'], 'String');
      if (data.hasOwnProperty('opt_status'))
        obj.optStatus = ApiClient.convertToType(data['opt_status'], 'String');
      if (data.hasOwnProperty('opt_in_sms'))
        obj.optInSms = ApiClient.convertToType(data['opt_in_sms'], 'Boolean');
      if (data.hasOwnProperty('opt_in_email'))
        obj.optInEmail = ApiClient.convertToType(data['opt_in_email'], 'Boolean');
      if (data.hasOwnProperty('preferred_name'))
        obj.preferredName = ApiClient.convertToType(data['preferred_name'], 'String');
      if (data.hasOwnProperty('patient_status'))
        obj.patientStatus = ApiClient.convertToType(data['patient_status'], 'String');
      if (data.hasOwnProperty('engagement_status'))
        obj.engagementStatus = ApiClient.convertToType(data['engagement_status'], 'String');
      if (data.hasOwnProperty('communications'))
        obj.communications = ApiClient.convertToType(data['communications'], 'String');
      if (data.hasOwnProperty('referral_date'))
        obj.referralDate = ApiClient.convertToType(data['referral_date'], 'Date');
      if (data.hasOwnProperty('patient_notes'))
        obj.patientNotes = ApiClient.convertToType(data['patient_notes'], 'String');
      if (data.hasOwnProperty('surgery_date'))
        obj.surgeryDate = ApiClient.convertToType(data['surgery_date'], 'Date');
      if (data.hasOwnProperty('surgery_time'))
        obj.surgeryTime = ApiClient.convertToType(data['surgery_time'], 'String');
      if (data.hasOwnProperty('surgery_status'))
        obj.surgeryStatus = ApiClient.convertToType(data['surgery_status'], 'String');
      if (data.hasOwnProperty('patient_type'))
        obj.patientType = ApiClient.convertToType(data['patient_type'], 'String');
      if (data.hasOwnProperty('visit_type'))
        obj.visitType = ApiClient.convertToType(data['visit_type'], 'String');
      if (data.hasOwnProperty('program'))
        obj.program = ApiClient.convertToType(data['program'], 'String');
      if (data.hasOwnProperty('service_line'))
        obj.serviceLine = ApiClient.convertToType(data['service_line'], 'String');
      if (data.hasOwnProperty('surgery_type'))
        obj.surgeryType = ApiClient.convertToType(data['surgery_type'], 'String');
      if (data.hasOwnProperty('surgeon'))
        obj.surgeon = ApiClient.convertToType(data['surgeon'], 'String');
      if (data.hasOwnProperty('health_system_contact'))
        obj.healthSystemContact = ApiClient.convertToType(data['health_system_contact'], 'String');
      if (data.hasOwnProperty('health_system'))
        obj.healthSystem = ApiClient.convertToType(data['health_system'], 'String');
      if (data.hasOwnProperty('hospital'))
        obj.hospital = ApiClient.convertToType(data['hospital'], 'String');
      if (data.hasOwnProperty('nih_grant_patient'))
        obj.nihGrantPatient = ApiClient.convertToType(data['nih_grant_patient'], 'Boolean');
      if (data.hasOwnProperty('assigned_staff_member'))
        obj.assignedStaffMember = ApiClient.convertToType(data['assigned_staff_member'], 'String');
      if (data.hasOwnProperty('pcp_physician'))
        obj.pcpPhysician = ApiClient.convertToType(data['pcp_physician'], 'String');
      if (data.hasOwnProperty('fin'))
        obj.fin = ApiClient.convertToType(data['fin'], 'String');
      if (data.hasOwnProperty('enrolled_date'))
        obj.enrolledDate = ApiClient.convertToType(data['enrolled_date'], 'Date');
      if (data.hasOwnProperty('outreach_assignee'))
        obj.outreachAssignee = ApiClient.convertToType(data['outreach_assignee'], 'String');
      if (data.hasOwnProperty('patient_number'))
        obj.patientNumber = ApiClient.convertToType(data['patient_number'], 'String');
      if (data.hasOwnProperty('first_name'))
        obj.firstName = ApiClient.convertToType(data['first_name'], 'String');
      if (data.hasOwnProperty('middle_name'))
        obj.middleName = ApiClient.convertToType(data['middle_name'], 'String');
      if (data.hasOwnProperty('last_name'))
        obj.lastName = ApiClient.convertToType(data['last_name'], 'String');
      if (data.hasOwnProperty('birth_date'))
        obj.birthDate = ApiClient.convertToType(data['birth_date'], 'Date');
      if (data.hasOwnProperty('gender_identity'))
        obj.genderIdentity = ApiClient.convertToType(data['gender_identity'], 'String');
      if (data.hasOwnProperty('administrative_gender'))
        obj.administrativeGender = ApiClient.convertToType(data['administrative_gender'], 'String');
      if (data.hasOwnProperty('races'))
        obj.races = ApiClient.convertToType(data['races'], [PatientsPatientRaces]);
      if (data.hasOwnProperty('ethnicities'))
        obj.ethnicities = ApiClient.convertToType(data['ethnicities'], [PatientsPatientEthnicities]);
      if (data.hasOwnProperty('pronouns'))
        obj.pronouns = ApiClient.convertToType(data['pronouns'], 'String');
      if (data.hasOwnProperty('identity_id'))
        obj.identityId = ApiClient.convertToType(data['identity_id'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('identity_external_id'))
        obj.identityExternalId = ApiClient.convertToType(data['identity_external_id'], 'String');
      if (data.hasOwnProperty('photon_health_patient_id'))
        obj.photonHealthPatientId = ApiClient.convertToType(data['photon_health_patient_id'], 'String');
      if (data.hasOwnProperty('nih_grant'))
        obj.nihGrant = ApiClient.convertToType(data['nih_grant'], 'Boolean');
      if (data.hasOwnProperty('comorbidities'))
        obj.comorbidities = ApiClient.convertToType(data['comorbidities'], ['String']);
      if (data.hasOwnProperty('clearances'))
        obj.clearances = ApiClient.convertToType(data['clearances'], ['String']);
      if (data.hasOwnProperty('smoking'))
        obj.smoking = ApiClient.convertToType(data['smoking'], 'Boolean');
      if (data.hasOwnProperty('diabetes'))
        obj.diabetes = ApiClient.convertToType(data['diabetes'], 'Boolean');
      if (data.hasOwnProperty('hypertension'))
        obj.hypertension = ApiClient.convertToType(data['hypertension'], 'Boolean');
      if (data.hasOwnProperty('anemia'))
        obj.anemia = ApiClient.convertToType(data['anemia'], 'Boolean');
      if (data.hasOwnProperty('race'))
        obj.race = ApiClient.convertToType(data['race'], 'String');
      if (data.hasOwnProperty('emergency_contact'))
        obj.emergencyContact = ApiClient.convertToType(data['emergency_contact'], 'String');
      if (data.hasOwnProperty('emergency_contact_phone_number'))
        obj.emergencyContactPhoneNumber = ApiClient.convertToType(data['emergency_contact_phone_number'], 'String');
      if (data.hasOwnProperty('mobile_phone_number'))
        obj.mobilePhoneNumber = ApiClient.convertToType(data['mobile_phone_number'], 'String');
      if (data.hasOwnProperty('home_phone_number'))
        obj.homePhoneNumber = ApiClient.convertToType(data['home_phone_number'], 'String');
      if (data.hasOwnProperty('outcomes_collected'))
        obj.outcomesCollected = ApiClient.convertToType(data['outcomes_collected'], 'Boolean');
      if (data.hasOwnProperty('length_of_stay'))
        obj.lengthOfStay = ApiClient.convertToType(data['length_of_stay'], 'Number');
      if (data.hasOwnProperty('postoperative_ed_visit'))
        obj.postoperativeEdVisit = ApiClient.convertToType(data['postoperative_ed_visit'], 'String');
      if (data.hasOwnProperty('postoperative_ed_visit_date'))
        obj.postoperativeEdVisitDate = ApiClient.convertToType(data['postoperative_ed_visit_date'], 'Date');
      if (data.hasOwnProperty('postoperative_readmission'))
        obj.postoperativeReadmission = ApiClient.convertToType(data['postoperative_readmission'], 'String');
      if (data.hasOwnProperty('postoperative_readmission_date'))
        obj.postoperativeReadmissionDate = ApiClient.convertToType(data['postoperative_readmission_date'], 'Date');
      if (data.hasOwnProperty('deceased'))
        obj.deceased = ApiClient.convertToType(data['deceased'], 'Boolean');
      if (data.hasOwnProperty('cancellation_reason'))
        obj.cancellationReason = ApiClient.convertToType(data['cancellation_reason'], 'String');
      if (data.hasOwnProperty('organization_ids'))
        obj.organizationIds = ApiClient.convertToType(data['organization_ids'], ['String']);
      if (data.hasOwnProperty('addresses_attributes'))
        obj.addressesAttributes = ApiClient.convertToType(data['addresses_attributes'], [InsurancePoliciesInsurancePolicySubscriberAttributesAddressesAttributes]);
      if (data.hasOwnProperty('phones_attributes'))
        obj.phonesAttributes = ApiClient.convertToType(data['phones_attributes'], [PatientsidPatientPhonesAttributes]);
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
      if (data.hasOwnProperty('metadata'))
        obj.metadata = ApiClient.convertToType(data['metadata'], {'String': Object});
    }
    return obj;
  }
}

/**
 * @member {String} email
 */
PatientsidPatient.prototype.email = undefined;

/**
 * Patient source status from patient tracker sheet
 * @member {String} sourceStatus
 */
PatientsidPatient.prototype.sourceStatus = undefined;

/**
 * Patient epic mrn from patient tracker sheet
 * @member {String} epicMrn
 */
PatientsidPatient.prototype.epicMrn = undefined;

/**
 * Patient epic mrn from patient tracker sheet
 * @member {String} optStatus
 */
PatientsidPatient.prototype.optStatus = undefined;

/**
 * Whether the patient may receive SMS messages.
 * @member {Boolean} optInSms
 */
PatientsidPatient.prototype.optInSms = undefined;

/**
 * Whether the patient may receive email messages.
 * @member {Boolean} optInEmail
 */
PatientsidPatient.prototype.optInEmail = undefined;

/**
 * @member {String} preferredName
 */
PatientsidPatient.prototype.preferredName = undefined;

/**
 * Health coach engagement status
 * @member {String} patientStatus
 */
PatientsidPatient.prototype.patientStatus = undefined;

/**
 * @member {String} engagementStatus
 */
PatientsidPatient.prototype.engagementStatus = undefined;

/**
 * Allowed values for the <code>communications</code> property.
 * @enum {String}
 * @readonly
 */
PatientsidPatient.CommunicationsEnum = {
  /**
   * value: "All"
   * @const
   */
  all: "All",

  /**
   * value: "SMS"
   * @const
   */
  SMS: "SMS",

  /**
   * value: "Email"
   * @const
   */
  email: "Email",

  /**
   * value: "None"
   * @const
   */
  none: "None"
};
/**
 * Preferred communication channels. Maps to opt_in_sms and opt_in_email.
 * @member {module:model/PatientsidPatient.CommunicationsEnum} communications
 */
PatientsidPatient.prototype.communications = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} referralDate
 */
PatientsidPatient.prototype.referralDate = undefined;

/**
 * Notes copied from the linked referred patient (read-only from referral; editable here).
 * @member {String} patientNotes
 */
PatientsidPatient.prototype.patientNotes = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} surgeryDate
 */
PatientsidPatient.prototype.surgeryDate = undefined;

/**
 * HH:MM (24-hour), hospital local time
 * @member {String} surgeryTime
 */
PatientsidPatient.prototype.surgeryTime = undefined;

/**
 * Surgery status
 * @member {String} surgeryStatus
 */
PatientsidPatient.prototype.surgeryStatus = undefined;

/**
 * Patient type from patient tracker sheet
 * @member {String} patientType
 */
PatientsidPatient.prototype.patientType = undefined;

/**
 * Visit type from patient tracker sheet
 * @member {String} visitType
 */
PatientsidPatient.prototype.visitType = undefined;

/**
 * @member {String} program
 */
PatientsidPatient.prototype.program = undefined;

/**
 * Patient service line from patient tracker sheet
 * @member {String} serviceLine
 */
PatientsidPatient.prototype.serviceLine = undefined;

/**
 * Surgery type from patient tracker sheet
 * @member {String} surgeryType
 */
PatientsidPatient.prototype.surgeryType = undefined;

/**
 * Surgery name from patient tracker sheet
 * @member {String} surgeon
 */
PatientsidPatient.prototype.surgeon = undefined;

/**
 * Main point of contact at practice from patient tracker sheet
 * @member {String} healthSystemContact
 */
PatientsidPatient.prototype.healthSystemContact = undefined;

/**
 * @member {String} healthSystem
 */
PatientsidPatient.prototype.healthSystem = undefined;

/**
 * @member {String} hospital
 */
PatientsidPatient.prototype.hospital = undefined;

/**
 * @member {Boolean} nihGrantPatient
 */
PatientsidPatient.prototype.nihGrantPatient = undefined;

/**
 * @member {String} assignedStaffMember
 */
PatientsidPatient.prototype.assignedStaffMember = undefined;

/**
 * @member {String} pcpPhysician
 */
PatientsidPatient.prototype.pcpPhysician = undefined;

/**
 * @member {String} fin
 */
PatientsidPatient.prototype.fin = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} enrolledDate
 */
PatientsidPatient.prototype.enrolledDate = undefined;

/**
 * @member {String} outreachAssignee
 */
PatientsidPatient.prototype.outreachAssignee = undefined;

/**
 * Patient number(s) from patient tracker sheet (e.g., '123, 456, 789')
 * @member {String} patientNumber
 */
PatientsidPatient.prototype.patientNumber = undefined;

/**
 * @member {String} firstName
 */
PatientsidPatient.prototype.firstName = undefined;

/**
 * @member {String} middleName
 */
PatientsidPatient.prototype.middleName = undefined;

/**
 * @member {String} lastName
 */
PatientsidPatient.prototype.lastName = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} birthDate
 */
PatientsidPatient.prototype.birthDate = undefined;

/**
 * Allowed values for the <code>genderIdentity</code> property.
 * @enum {String}
 * @readonly
 */
PatientsidPatient.GenderIdentityEnum = {
  /**
   * value: "female"
   * @const
   */
  female: "female",

  /**
   * value: "male"
   * @const
   */
  male: "male",

  /**
   * value: "non_binary"
   * @const
   */
  nonBinary: "non_binary",

  /**
   * value: "non_disclose"
   * @const
   */
  nonDisclose: "non_disclose",

  /**
   * value: "other"
   * @const
   */
  other: "other",

  /**
   * value: "transgender_female"
   * @const
   */
  transgenderFemale: "transgender_female",

  /**
   * value: "transgender_male"
   * @const
   */
  transgenderMale: "transgender_male",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * The gender the patient identifies with. The Patient's gender identity is used as guidance(e.g. for staff) about how to interact with the patient.
 * @member {module:model/PatientsidPatient.GenderIdentityEnum} genderIdentity
 */
PatientsidPatient.prototype.genderIdentity = undefined;

/**
 * Allowed values for the <code>administrativeGender</code> property.
 * @enum {String}
 * @readonly
 */
PatientsidPatient.AdministrativeGenderEnum = {
  /**
   * value: "unknown"
   * @const
   */
  unknown: "unknown",

  /**
   * value: "male"
   * @const
   */
  male: "male",

  /**
   * value: "female"
   * @const
   */
  female: "female",

  /**
   * value: "not_applicable"
   * @const
   */
  notApplicable: "not_applicable"
};
/**
 * The gender of the patient to be used for administrative purposes.
 * @member {module:model/PatientsidPatient.AdministrativeGenderEnum} administrativeGender
 */
PatientsidPatient.prototype.administrativeGender = undefined;

/**
 * The patient's race as identified by the patient.
 * @member {Array.<module:model/PatientsPatientRaces>} races
 */
PatientsidPatient.prototype.races = undefined;

/**
 * The patient's ethnicity as identified by the patient.
 * @member {Array.<module:model/PatientsPatientEthnicities>} ethnicities
 */
PatientsidPatient.prototype.ethnicities = undefined;

/**
 * The patient's pronouns as identified by the patient.
 * @member {String} pronouns
 */
PatientsidPatient.prototype.pronouns = undefined;

/**
 * Pass an identity_id returned by a submission or a lead to link the previously generated identity to the new user being created.
 * @member {String} identityId
 */
PatientsidPatient.prototype.identityId = undefined;

/**
 * Provide a custom reference to the patient.
 * @member {String} externalId
 */
PatientsidPatient.prototype.externalId = undefined;

/**
 * Provide a custom identity reference for the patient.
 * @member {String} identityExternalId
 */
PatientsidPatient.prototype.identityExternalId = undefined;

/**
 * Provide the ID of the associated Photon Health patient.
 * @member {String} photonHealthPatientId
 */
PatientsidPatient.prototype.photonHealthPatientId = undefined;

/**
 * @member {Boolean} nihGrant
 */
PatientsidPatient.prototype.nihGrant = undefined;

/**
 * @member {Array.<String>} comorbidities
 */
PatientsidPatient.prototype.comorbidities = undefined;

/**
 * @member {Array.<String>} clearances
 */
PatientsidPatient.prototype.clearances = undefined;

/**
 * @member {Boolean} smoking
 */
PatientsidPatient.prototype.smoking = undefined;

/**
 * @member {Boolean} diabetes
 */
PatientsidPatient.prototype.diabetes = undefined;

/**
 * @member {Boolean} hypertension
 */
PatientsidPatient.prototype.hypertension = undefined;

/**
 * @member {Boolean} anemia
 */
PatientsidPatient.prototype.anemia = undefined;

/**
 * @member {String} race
 */
PatientsidPatient.prototype.race = undefined;

/**
 * @member {String} emergencyContact
 */
PatientsidPatient.prototype.emergencyContact = undefined;

/**
 * @member {String} emergencyContactPhoneNumber
 */
PatientsidPatient.prototype.emergencyContactPhoneNumber = undefined;

/**
 * @member {String} mobilePhoneNumber
 */
PatientsidPatient.prototype.mobilePhoneNumber = undefined;

/**
 * @member {String} homePhoneNumber
 */
PatientsidPatient.prototype.homePhoneNumber = undefined;

/**
 * @member {Boolean} outcomesCollected
 */
PatientsidPatient.prototype.outcomesCollected = undefined;

/**
 * @member {Number} lengthOfStay
 */
PatientsidPatient.prototype.lengthOfStay = undefined;

/**
 * @member {String} postoperativeEdVisit
 */
PatientsidPatient.prototype.postoperativeEdVisit = undefined;

/**
 * @member {Date} postoperativeEdVisitDate
 */
PatientsidPatient.prototype.postoperativeEdVisitDate = undefined;

/**
 * @member {String} postoperativeReadmission
 */
PatientsidPatient.prototype.postoperativeReadmission = undefined;

/**
 * @member {Date} postoperativeReadmissionDate
 */
PatientsidPatient.prototype.postoperativeReadmissionDate = undefined;

/**
 * @member {Boolean} deceased
 */
PatientsidPatient.prototype.deceased = undefined;

/**
 * @member {String} cancellationReason
 */
PatientsidPatient.prototype.cancellationReason = undefined;

/**
 * Associate the patient with organizations.
 * @member {Array.<String>} organizationIds
 */
PatientsidPatient.prototype.organizationIds = undefined;

/**
 * @member {Array.<module:model/InsurancePoliciesInsurancePolicySubscriberAttributesAddressesAttributes>} addressesAttributes
 */
PatientsidPatient.prototype.addressesAttributes = undefined;

/**
 * @member {Array.<module:model/PatientsidPatientPhonesAttributes>} phonesAttributes
 */
PatientsidPatient.prototype.phonesAttributes = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
PatientsidPatient.prototype.tagList = undefined;

/**
 * Any JSON-formatted data you want to associate with this object
 * @member {Object.<String, Object>} metadata
 */
PatientsidPatient.prototype.metadata = undefined;
